module.exports = __webpack_public_path__ + "img/d6sj-btn.d5db6f59.png";